var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-detail-info--inner"},[_c('info-wallet',{staticClass:"user-details-contents__items"}),_c('info-memo',{staticClass:"user-details-contents__items"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }